import React, { useEffect, useState } from 'react';

import Divider from '@mui/material/Divider';

import EscalationsHistory from "./escalationsHistory";
import ResolveEscalationModal from "../../components/ResolveEscalationModal";

export default function EscalationEditor({ jobId, jobInfo, userCanEditJob, activeEscalation, escalationHistory, escalation, setEscalation}) {

  return (
    <div>
      {
        activeEscalation ?
          <ResolveEscalationModal 
            jobInfo={jobInfo}
            activeEscalation={activeEscalation} 
            escalationHistory={escalationHistory}
            userCanEditJob={userCanEditJob}
            escalation={escalation}
            setEscalation={setEscalation}
          />  
          : <h4 style={{ color: 'var(--orange) ' }}>There are no escalations for this job</h4>
      }

      <div style={{ margin: "1em 0 2em 0" }} >
        <Divider sx={{ borderColor: 'var(--light-yellow)', marginTop: '2em' }} />
      </div>
      {/* /////////////////////////////////////////////////////////////// */}
      <div style={{ marginBottom: '2em' }}>
        <p style={{ color: "var(--orange)", margin:'0 0 1em 0' }}>Escalation History</p>
        <EscalationsHistory  history={escalationHistory}/>
      </div>
      {/* /////////////////////////////////////////////////////////////// */}
    </div>
  )
}